import React from 'react';
import { CHANGELOG } from '../changelog';

const C = {
  primary: 'var(--c-primary)', secondary: 'var(--c-secondary)', bg: 'var(--c-bg)',
  surface: 'var(--c-surface)', border: 'var(--c-border)', text: 'var(--c-text)',
  textMuted: 'var(--c-textMuted)', ok: 'var(--c-ok)', warn: 'var(--c-warn)', danger: 'var(--c-danger)',
};

export const Changelog: React.FC = () => {
  return (
    <div style={{ maxWidth: 820 }}>
      <h1 style={{ color: C.primary, fontSize: 26, margin: '0 0 6px' }}>Changelog</h1>
      <p style={{ color: C.textMuted, margin: '0 0 22px' }}>What’s changed in each release of HelpDesk Pro.</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {CHANGELOG.map((r, i) => (
          <div key={r.version} style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 10, padding: 18 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
              <span style={{ fontSize: 17, fontWeight: 700, color: C.text }}>{r.version}</span>
              {i === 0 && (
                <span style={{
                  fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px',
                  color: '#fff', background: C.ok, borderRadius: 999, padding: '2px 8px',
                }}>Current</span>
              )}
              {r.date && <span style={{ fontSize: 12, color: C.textMuted, marginLeft: 'auto' }}>{r.date}</span>}
            </div>
            <ul style={{ margin: 0, paddingLeft: 18, color: C.text, fontSize: 14, lineHeight: 1.6 }}>
              {r.highlights.map((h, j) => <li key={j} style={{ marginBottom: 4 }}>{h}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
